module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-report-2.5544c907.svg";